import styled from 'styled-components';

export const LoadingFlavourText = styled.div`
  font-size: 1.4rem;
  text-align: center;
  line-height: 1.6rem;
  text-shadow: 1px 1px #000;
`;
